// extracted by mini-css-extract-plugin
export default {"modify_order_header":"fs","center":"gs","empty":"hs","pending":"is","referralTitle":"js","wrapper":"ks","title":"ls","tabs":"ms","tab":"ns","active":"os","btn":"ps","rewards_table":"qs"};
    if(module.hot) {
      // 1711394575984
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  